// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchWithinStyles } from "@eisinc/Overrides/Widgets/ProductList/ProductListSearchWithin";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import Search from "@insite/mobius/Icons/Search";
import { css } from "styled-components";

searchWithinStyles.titleText = {
    size: fontConfig.singleLinexSmall.size,
    weight: fontConfig.weight.medium,
    lineHeight: fontConfig.singleLinexSmall.lineHeight,
    css: css`
        display: block;
        background: ${color("common.ui2")};
        padding: 8px;
    `,
};
searchWithinStyles.searchTextField = {
    iconProps: {
        src: Search,
    },
    cssOverrides: {
        formField: css`
                width: 100%;
                padding: 8px;
                border-bottom: 1px solid ${color("common.border")};

                > div {
                    button {
                        position: absolute;
                        left: 0;
                        svg {
                            color: ${color("common.ui1")};
                        }
                    }
                    input {
                        padding-right: 32px !important;
                    }
                }
            `,
    },

};
searchWithinStyles.wrapper = {
    css: css`
            border: 1px solid ${color("common.ui3")};
        `,
};